import React, { useContext } from 'react';
import OdxAreaHeader from '../../../OdxComponents/NativeOdx/Odx-AreaHeader';
import OdxBreadcrumbs from "../../../OdxComponents/NativeOdx/Odx-Breadcrumbs";
import { GithubDataContext } from "../githubDataContext";

const Info: React.FC = () => {
    const { org, slug, costCenter } = useContext(GithubDataContext);

    const baseId = 'github-info';

    return (
        <div id={`${baseId}-view`}>
            <OdxBreadcrumbs id={`${baseId}-breadcrumbs`}/>
            <OdxAreaHeader
                title="Module Info"
                text="Module Info"
                className={"!pl-0"}
                id={`${baseId}-header`}
            />
            <div id={`${baseId}-content`}>
                <div id={`${baseId}-org`}>
                    <strong>Organization:</strong> {org}
                </div>
                <div id={`${baseId}-slug`}>
                    <strong>Slug:</strong> {slug}
                </div>
                <div id={`${baseId}-cost-center`}>
                    <strong>Cost Center:</strong> {costCenter}
                </div>
            </div>
        </div>
    );
};

export default Info;
